import * as style from '@/avatars/index';
import { truncateWalletAddress } from '@/utils';
import { HStack, Text } from '@chakra-ui/react';
import { createAvatar } from '@dicebear/core';
import { CopyText } from './copy-text';
import { Avatar, AvatarProps } from './ui/avatar';
export const GoonAvatar = ({
  seed,
  withAddress,
  ...imageProps
}: { seed: string | undefined; withAddress?: boolean } & AvatarProps) => {
  const avatar = createAvatar(style, {
    seed: seed?.toLowerCase(),
  });
  if (withAddress) {
    return (
      <HStack>
        <CopyText
          value={seed}
          px={1}
          py={4}
          rounded="md"
          variant="subtle"
          _hover={{
            bgColor: 'bg.muted',
          }}
        >
          <Avatar src={avatar.toDataUri()} {...imageProps} />
          <Text fontWeight="500" fontSize="md" color="fg">
            {truncateWalletAddress(seed)}
          </Text>
        </CopyText>
      </HStack>
    );
  }
  return <Avatar src={avatar.toDataUri()} {...imageProps} />;
};
